// ARQUIVO ATUALIZADO
import React from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';

const ConfirmDeleteModal = ({ type, item, onConfirm, onCancel }) => {
    if (!item) return null;

    // --- INÍCIO DA ALTERAÇÃO: Lógica para exibir o nome do item a ser deletado ---
    let itemType = 'item';
    let itemName = '';

    switch (type) {
        case 'task':
            itemType = 'a tarefa';
            itemName = `"${item?.title}"`;
            break;
        case 'client':
            itemType = 'o cliente';
            itemName = `"${item?.name}"`;
            break;
        case 'project':
            itemType = 'o projeto';
            itemName = `"${item?.name}"`;
            break;
        case 'comment':
            itemType = 'o comentário';
            itemName = `"${item?.content?.substring(0, 30)}..."`;
            break;
        default:
            itemType = 'este item';
            break;
    }
    // --- FIM DA ALTERAÇÃO ---

    const footerButtons = (
        <>
            <GlassButton onClick={onCancel} variant="minimal">
                Cancelar
            </GlassButton>
            <GlassButton onClick={() => onConfirm(item.id)} className="bg-red-500 hover:bg-red-600">
                Excluir
            </GlassButton>
        </>
    );

    return (
        <Modal
            isOpen={!!item}
            onClose={onCancel}
            title={`Confirmar Exclusão`}
            footer={footerButtons}
            maxWidth="max-w-md"
        >
            <p className="text-gray-300">
                Tem certeza que deseja excluir {itemType} <strong>{itemName}</strong>?
            </p>
            <p className="text-sm mt-2 text-red-400">Esta ação não pode ser desfeita.</p>
        </Modal>
    );
};

export default ConfirmDeleteModal;